import { Typography } from "@packages/ds";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const GroupHeader = styled(Typography.Label)`
  display: block;
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 0 8px 8px;
  :after {
    content: "";
    flex: 1;
    height: 1px;
    background-color: var(--mode-border-neutral-weakest);
  }
  color: var(--mode-text-neutral-weakest);
`;

export const OrganizationLink = styled(Link)`
  all: unset;
  cursor: pointer;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const OrganizationListLink = styled.li<{ $isActive: boolean }>`
  border-radius: var(--box-wrapper-section-border-radius);
  color: var(--mode-text-neutral-default-weak);
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 24px;
  color: var(--mode-text-neutral-default-weak);

  font-family: var(--ff-sans, "Open Sans");
  font-size: var(--fs-m);
  font-style: normal;
  font-weight: 400;
  ${({ $isActive }) =>
    !$isActive
      ? `&:hover {
    color: var(--mode-text-primary-default);
    background-color: var(--mode-bg-primary-weakest);
  }`
      : `
    color: var(--mode-text-neutral-default-weak);
    background-color: var(--mode-bg-neutral-weaker);
  `}
`;

export const OrganizationListContainer = styled.ul`
  box-sizing: border-box;
  padding: 0 24px 8px 16px;
  display: flex;
  flex: 1;
  overflow: auto;
  flex-direction: column;
  gap: 4px;
  /* adds margin if the input box is visible */
  div + & {
    margin-top: 8px;
  }
`;
